/* A la Carte – swipe gallery (styles included below so they load after base.css) */
(function () {
  if (document.getElementById('alc-gallery-style')) return;
  var s = document.createElement('style');
  s.id = 'alc-gallery-style';
  s.textContent = "/* ===== A la Carte – full-screen swipe gallery ===== */\n\n.product-media-modal__dialog {\n  height: 100vh;\n  height: 100dvh;\n}\n\n.product-media-modal__content {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  width: 100% !important;\n  height: 100% !important;\n  overflow: hidden !important;\n  padding: 5.6rem 1rem 8rem !important;\n  box-sizing: border-box;\n  touch-action: pinch-zoom;\n}\n\n/* Only one photo visible at a time */\n.product-media-modal__content > [data-media-id]:not(.active) {\n  display: none !important;\n}\n\n/* Photo fills the screen without cropping or extra zoom */\n.product-media-modal__content > img.active {\n  display: block !important;\n  width: 100% !important;\n  height: 100% !important;\n  max-width: 100% !important;\n  max-height: 100% !important;\n  object-fit: contain !important;\n  margin: 0 !important;\n}\n\n/* Videos / 3D models */\n.product-media-modal__content > deferred-media.active,\n.product-media-modal__content > .product-media-modal__model.active {\n  display: block !important;\n  width: 100% !important;\n  height: auto !important;\n  margin: auto !important;\n}\n\n/* Gentle slide when changing photo */\n.alc-slide-next { animation: alcSlideNext 0.3s ease; }\n.alc-slide-prev { animation: alcSlidePrev 0.3s ease; }\n\n@keyframes alcSlideNext {\n  from { opacity: 0; transform: translateX(8%); }\n  to { opacity: 1; transform: none; }\n}\n\n@keyframes alcSlidePrev {\n  from { opacity: 0; transform: translateX(-8%); }\n  to { opacity: 1; transform: none; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .alc-slide-next,\n  .alc-slide-prev { animation: none; }\n}\n\n/* Arrows + counter */\n.alc-gallery-controls {\n  position: fixed;\n  bottom: calc(20px + env(safe-area-inset-bottom));\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 4px 10px;\n  background: rgba(255, 255, 255, 0.94);\n  border-radius: 40px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);\n}\n\n.alc-gallery-controls[hidden] {\n  display: none;\n}\n\n.alc-gallery-controls button {\n  min-width: 44px;\n  min-height: 44px;\n  background: transparent;\n  border: 0;\n  cursor: pointer;\n  font-size: 20px;\n  color: #555548;\n}\n\n.alc-gallery-counter {\n  font-size: 13px;\n  color: #555548;\n  white-space: nowrap;\n}\n\n@media (max-width: 749px) {\n  .product-media-modal__content {\n    padding: 5.6rem 0.5rem 8rem !important;\n  }\n}\n";
  document.head.appendChild(s);
})();

if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.currentIndex = 0;
        this.galleryReady = false;
      }

      get content() {
        return this.querySelector('.product-media-modal__content');
      }

      getMedia() {
        return Array.from(this.content.querySelectorAll(':scope > [data-media-id]'));
      }

      show(opener) {
        super.show(opener);
        this.setupGallery();
        this.showActiveMedia();
      }

      hide() {
        super.hide();
      }

      showActiveMedia() {
        const media = this.getMedia();
        const id = this.openedBy ? this.openedBy.getAttribute('data-media-id') : null;
        const index = media.findIndex((el) => el.getAttribute('data-media-id') === id);
        this.showSlide(index >= 0 ? index : 0, 0);
      }

      go(step) {
        if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
        this.showSlide(this.currentIndex + step, step);
      }

      showSlide(index, direction = 0) {
        const media = this.getMedia();
        if (!media.length) return;

        this.currentIndex = (index + media.length) % media.length;

        media.forEach((el, i) => {
          const isActive = i === this.currentIndex;
          el.classList.toggle('active', isActive);
          el.classList.remove('alc-slide-next', 'alc-slide-prev');
          if (isActive && direction) {
            void el.offsetWidth; // restart the animation
            el.classList.add(direction > 0 ? 'alc-slide-next' : 'alc-slide-prev');
          }
        });

        // Load the current photo and its neighbours right away so swiping feels instant
        [0, 1, -1].forEach((offset) => {
          const el = media[(this.currentIndex + offset + media.length) % media.length];
          if (el && el.tagName === 'IMG') el.loading = 'eager';
        });

        const active = media[this.currentIndex];
        const template = active.querySelector('template');
        if (
          active.nodeName === 'DEFERRED-MEDIA' &&
          template &&
          template.content.querySelector('.js-youtube')
        ) {
          active.loadContent();
        }

        if (this.counter) this.counter.textContent = `${this.currentIndex + 1} / ${media.length}`;
        if (this.controls) this.controls.hidden = media.length < 2;
      }

      setupGallery() {
        if (this.galleryReady) return;
        this.galleryReady = true;

        const dialog = this.querySelector('.product-media-modal__dialog');
        const controls = document.createElement('div');
        controls.className = 'alc-gallery-controls';
        controls.innerHTML = `
          <button type="button" class="alc-gallery-prev" aria-label="Previous photo">&#10094;</button>
          <span class="alc-gallery-counter" aria-live="polite"></span>
          <button type="button" class="alc-gallery-next" aria-label="Next photo">&#10095;</button>
        `;
        dialog.appendChild(controls);
        this.controls = controls;
        this.counter = controls.querySelector('.alc-gallery-counter');

        // Dawn closes the lightbox on any mouse click; stop that for the arrows
        controls.addEventListener('pointerup', (e) => e.stopPropagation());
        controls.querySelector('.alc-gallery-prev').addEventListener('click', () => this.go(-1));
        controls.querySelector('.alc-gallery-next').addEventListener('click', () => this.go(1));

        // Swipe left / right on phones
        let startX = 0;
        let startY = 0;
        let tracking = false;

        this.content.addEventListener(
          'touchstart',
          (e) => {
            if (e.touches.length !== 1) {
              tracking = false; // two fingers = pinch, not a swipe
              return;
            }
            tracking = true;
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
          },
          { passive: true }
        );

        this.content.addEventListener(
          'touchend',
          (e) => {
            if (!tracking) return;
            tracking = false;
            const t = e.changedTouches[0];
            const dx = t.clientX - startX;
            const dy = t.clientY - startY;
            if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) {
              this.go(dx < 0 ? 1 : -1);
            }
          },
          { passive: true }
        );

        // Arrow keys on desktop
        this.addEventListener('keydown', (e) => {
          if (!this.hasAttribute('open')) return;
          if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.go(1);
          } else if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.go(-1);
          }
        });
      }
    }
  );
}
